import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {Scanner3dModel} from '../../../api/entity/scanner3d.model';
import {Scanner3dConverter} from '../../../api/entity/converter/scanner3d.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class Scanner3dDataService extends AbstractDataServiceV2<Scanner3dModel, Scanner3dConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: Scanner3dConverter) {
        super('Scanner3d', http, httpUrlGenerator, logger, config, converter);
    }
}
